import HeroSection from '../components/About/HeroSection';
import Footer from '../components/Footer';
import NavBar from '../components/NavBar';
import ContactMap from '../components/ContactMap'


const About = () => {
	return (
		<div className="min-h-screen">
			<NavBar/>
			<HeroSection />
			<ContactMap	/>
			<Footer/>
		</div>
	);
};

export default About;